var $1830a539e98c7baf$exports = {};
$1830a539e98c7baf$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u0434\u043E ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0435 ".concat(args.date);
  },
  "finishRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0434\u043E\u0432\u044A\u0440\u0448\u0438\u0442\u0435 \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B",
  "maximumDate": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
  "minimumDate": "\u041F\u044A\u0440\u0432\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
  "next": "\u041D\u0430\u043F\u0440\u0435\u0434",
  "previous": "\u041D\u0430\u0437\u0430\u0434",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0438\u0441\u0442\u044A\u043F\u0438\u0442\u0435 \u043A\u044A\u043C \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B",
  "todayDate": function todayDate(args) {
    return "\u0414\u043D\u0435\u0441, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u0414\u043D\u0435\u0441, ".concat(args.date, " \u0441\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438");
  }
};
export { $1830a539e98c7baf$exports as default };